import { Routes } from '@angular/router';
import { AppRoute } from '@sportlogiq/app-routing.models';
import { AuthGuard } from '../core/auth-guard.service';
import { LoginComponent } from './login.component';
import { LoginPageSectionsEnum } from './login.types';
import { LoginGuard } from './login.guard';

export const loginRoutes: Routes = [
    {
        path: AppRoute.LOGIN,
        component: LoginComponent,
        canActivate: [LoginGuard, AuthGuard],
        data: {
            title: 'ROUTE_TITLES.Login',
            section: LoginPageSectionsEnum.Login,
            noSessionOnly: true
        },
    },
    {
        path: AppRoute.FORGOT_PASSWORD,
        component: LoginComponent,
        canActivate: [LoginGuard, AuthGuard],
        data: {
            title: 'ROUTE_TITLES.ForgotPassword',
            section: LoginPageSectionsEnum.ForgotPassword,
            noSessionOnly: true
        },
    },
    {
        path: `${AppRoute.CREATE_NEW_PASSWORD}/:uniqueToken`,
        component: LoginComponent,
        canActivate: [LoginGuard, AuthGuard],
        data: {
            title: 'ROUTE_TITLES.CreateNewPassword',
            section: LoginPageSectionsEnum.CreateNewPassword,
            noSessionOnly: true
        },
    },
];
